import { COUNTRY_LIST } from '@shared/utils/address/constants';

// Legacy language-only locales map to their canonical BCP-47 form so older
// events resolve to their country instead of falling back to US. Mirrors the
// backward-compat mapping in LanguagePicker.constants — kept inline so this
// util stays dependency-free (importing that module pulls in @shared/core) and
// unit-testable.
const LEGACY_LOCALE_MAP: Readonly<Record<string, string>> = {
  en: 'en-US',
  de: 'de-DE',
  es: 'es-ES',
  fr: 'fr-FR',
  it: 'it-IT',
  ja: 'ja-JP',
};

// Falls back to US when the locale has no recognized region.
export const deriveCountryDefaults = (locale: string | undefined) => {
  const normalized = locale ? (LEGACY_LOCALE_MAP[locale] ?? locale) : '';
  const [, region] = normalized.split('-');
  const code = region?.toUpperCase();
  const match = code ? COUNTRY_LIST.find(c => c.value === code) : undefined;
  return {
    country: match?.label ?? 'United States',
    countryCode: match?.value ?? 'US',
    phoneCountryCode: (match?.value ?? 'US').toLowerCase(),
  };
};
